import { Injectable } from '@angular/core';
import { Tarif } from '@wz-models';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class TaggingService {
  reponseNiveauRemboursement(
    event_tunnel_reponse_soins: string,
    event_tunnel_reponse_hospitalisation: string,
    event_tunnel_reponse_dentaire: string,
    event_tunnel_reponse_optique: string,
    event_tunnel_reponse_auditive: string,
  ) {
    let age: any = localStorage.getItem('AgeSouscripteur');
    let ageDouble = 0;

    let datatc: any = {
      event_id: 'action',
      event_categorie: 'tunnel reponse',
      event_nom: 'reponse question',
      event_tunnel: 'comparer les offres',
      event_tunnel_question: 'vos besoins – niveau de remboursement souhaité ?',
      event_tunnel_reponse_soins: event_tunnel_reponse_soins,
      event_tunnel_reponse_hospitalisation:
        event_tunnel_reponse_hospitalisation,
      event_tunnel_reponse_dentaire: event_tunnel_reponse_dentaire,
      event_tunnel_reponse_optique: event_tunnel_reponse_optique,
      event_tunnel_reponse_auditive: event_tunnel_reponse_auditive,
    };

    if (!isNaN(parseFloat(age))) {
      ageDouble = parseFloat(age);
    }

    if (ageDouble >= 0) {
      datatc['event_user_age'] = ageDouble + '';
      window['tc_vars']
        ? (window['tc_vars']['event_user_age'] = ageDouble + '')
        : '';
    }
    window['tC'].event.action(this, datatc);
  }

  reponseUneQuestion(event_tunnel_question: string, event_tunnel_reponse: any) {
    let age: any = localStorage.getItem('AgeSouscripteur');
    let ageDouble = 0;

    let datatc: any = {
      event_id: 'action',
      event_categorie: 'tunnel reponse',
      event_nom: 'reponse question',
      event_tunnel: 'comparer les offres',
      event_tunnel_question: event_tunnel_question,
      event_tunnel_reponse: event_tunnel_reponse,
    };

    if (!isNaN(parseFloat(age))) {
      ageDouble = parseFloat(age);
    }

    if (ageDouble >= 0) {
      datatc['event_user_age'] = ageDouble + '';
      window['tc_vars']
        ? (window['tc_vars']['event_user_age'] = ageDouble + '')
        : '';
    }
    window['tC'].event.action(this, datatc);
  }

  pageTunnel(event_nom: string) {
    let datatc: any = {
      event_id: 'page',
      event_categorie: 'affichage tunnel etape',
      event_nom: event_nom,
    };
    let age: any = localStorage.getItem('AgeSouscripteur');
    let ageDouble = 0;

    if (!isNaN(parseFloat(age))) {
      ageDouble = parseFloat(age);
    }

    if (ageDouble >= 0) {
      datatc['event_user_age'] = ageDouble + '';
      window['tc_vars']
        ? (window['tc_vars']['event_user_age'] = ageDouble + '')
        : '';
    }

    window['tC'].event.page(this, datatc);
  }

  refresh(
    nombreTotalQuestionsAPoser: string,
    tunnel_num_etape: string,
    tunnel_nom_etape: string,
    tunnel_nom_sous_etape: string,
    visiteurId: string,
  ) {
    const tunnelElement = document.querySelector('body > wz-app-tunnel');
    if (tunnelElement) {
      tunnelElement.scrollTo(0, 0);
    }
    window['tc_vars'] = {
      env_site: 'meilleurtaux santé',
      env_work: 'production',
      env_visiteur_id: visiteurId,
      // env_param: 'FIGARO',
      page_nom: 'devis',
      page_metier: 'sante',
      page_template: 'tunnel',
      page_tunnel: 'comparer les offres',
      tunnel_demande: 'comparaison des offres',
      tunnel_etape: nombreTotalQuestionsAPoser,
      tunnel_num_etape: tunnel_num_etape,
      tunnel_nom_etape: tunnel_nom_etape,
      tunnel_nom_sous_etape: tunnel_nom_sous_etape,
    };

    if (window['tC']) {
      let datatc: any = {
        event_id: 'page',
        event_categorie: 'affichage tunnel etape',
        event_nom: tunnel_nom_etape + ' – ' + tunnel_nom_sous_etape,
      };
      let age: any = localStorage.getItem('AgeSouscripteur');
      let ageDouble = 0;

      if (!isNaN(parseFloat(age))) {
        ageDouble = parseFloat(age);
      }

      if (ageDouble >= 0) {
        datatc['event_user_age'] = ageDouble + '';
        window['tc_vars']['event_user_age'] = ageDouble + '';
      }
      window['tC'].event.page(this, datatc);
    }
  }

  refreshSouscription(
    tunnel_num_etape: string,
    tunnel_nom_etape: string,
    visiteurId: string,
    sha256Mail: string,
    lead_temp: string,
    tarif: Tarif,
  ) {
    const tunnelElement = document.querySelector('body > wz-app-tunnel');
    if (tunnelElement) {
      tunnelElement.scrollTo(0, 0);
    }
    window['tc_vars'] = {
      env_site: 'meilleurtaux santé',
      env_work: 'production',
      env_visiteur_id: visiteurId,
      page_nom: 'souscription',
      page_metier: 'sante',
      page_template: 'tunnel',
      page_tunnel: 'souscrire en ligne',
      tunnel_demande: 'souscription',
      tunnel_etape: '3',
      tunnel_num_etape: tunnel_num_etape,
      tunnel_nom_etape: tunnel_nom_etape,
      user_email_sha256: sha256Mail,
      dossier_id: lead_temp,
      lead_id: lead_temp,
      tunnel_produit: tarif?.produitTarif ?? '',
      tunnel_partenaire: this.getProduitPartenaires(tarif),
    };

    let age: any = localStorage.getItem('AgeSouscripteur');

    let ageDouble = 0;

    if (!isNaN(parseFloat(age))) {
      ageDouble = parseFloat(age);
    }

    let datatc: any = {
      event_id: 'page',
      event_categorie: 'affichage tunnel etape',
      event_nom: tunnel_num_etape + ' - ' + tunnel_nom_etape,
    };

    if (ageDouble >= 0) {
      datatc['event_user_age'] = ageDouble + '';
      window['tc_vars']
        ? (window['tc_vars']['event_user_age'] = ageDouble + '')
        : '';
    }

    window['tC'].event.page(this, datatc);
  }

  createVisiteurId() {
    let dateConnection = new Date().getTime() + '@meilleurtaux';
    let id = CryptoJS.MD5(dateConnection).toString();

    this.setCookie('visiteurIdMTX', id, 395);
    return id;
  }

  checkVisiteurId() {
    let id = '';
    if (this.getCookie('visiteurIdMTX') == '') {
      id = this.createVisiteurId();
    } else {
      id = this.getCookie('visiteurIdMTX');
    }
    return id;
  }

  private getCookie(name: string) {
    let ca: Array<string> = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }

  private setCookie(
    name: string,
    value: string,
    expireDays: number,
    path: string = '',
  ) {
    let d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    let expires: string = `expires=${d.toUTCString()}`;
    let cpath: string = path ? `; path=${path}` : '';
    document.cookie = `${name}=${value}; ${expires}${cpath}`;
  }

  private getProduitPartenaires(tarif: Tarif) {
    let compagnie = '';
    if (
      tarif.produitTarif == 'CEGEMAEss' ||
      tarif.produitTarif == 'CEGEMAV' ||
      tarif.produitTarif == 'CEGE_EQUILIBRE' ||
      tarif.produitTarif == 'CEGEMA_FLEXI_SANTE_NON_RESPONSABLE' ||
      tarif.produitTarif == 'CEGEMA_FLEXI_SANTE_RESPONSABLE' ||
      tarif.produitTarif == 'KEREIS_SERENITE'
    ) {
      compagnie = 'CEGEMA';
    } else if (
      tarif.produitTarif == 'ESSENTIEL_PLUS_SANTE_ECO' ||
      tarif.produitTarif == 'ESSENTIEL_PLUS_SANTE' ||
      tarif.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE_ECO' ||
      tarif.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE' ||
      tarif.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR_ECO' ||
      tarif.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR' ||
      tarif.produitTarif == 'AESIO_IMM_SANTE_FAMILLE_ECO' ||
      tarif.produitTarif == 'AESIO_IMM_SANTE_FAMILLE' ||
      tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR_ECO' ||
      tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR' ||
      tarif.produitTarif == 'RELAXEO2' ||
      tarif.produitTarif == 'PROGR_SANTE_SENIOR' ||
      tarif.produitTarif == 'PROGR_SANTE_FAMILLE' ||
      tarif.produitTarif == 'AC_PRIVILEGE'
    ) {
      compagnie = 'MEILLEURSTAUX SANTE';
    } else if (
      tarif.produitTarif == 'PARTICULIER' ||
      tarif.produitTarif == 'SWLF_RETRAITES'
    ) {
      compagnie = 'SWISS LIFE';
    } else if (tarif.produitTarif == 'VITAMIN3') {
      compagnie = 'APIVIA';
    } else if (
      tarif.produitTarif == 'ZEN_SANTE_55_PLUS' ||
      tarif.produitTarif == 'ZEN_SANTE_FAMILLE' ||
      tarif.produitTarif == 'ZEN_SANTE_SENIOR' ||
      tarif.produitTarif == 'ZEN_SANTE_SENIOR_ECO'
    ) {
      compagnie = 'ZENIOO';
    }
    return compagnie;
  }
}
